<template>
    <div>
        <v-expansion-panels v-model="pan" focusable>
            <v-expansion-panel v-for="(item, index) in items" :key="index" :value="index === expand"
                class="border rounded-0">
                <v-expansion-panel-header :ripple="!(item.title == 'Contactos')">
                    <div class=" d-flex align-center text-subtitle-1 mt-1">
                        <v-icon :color="item.color" class="mr-2">{{ item.icon }}</v-icon>
                        {{ item.title }}
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <component v-bind="item.props" :is="item.component" :index="index" @isCorrectForm="formCorrect">
                    </component>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
//mapeo axios
import { mapGetters, mapActions } from 'vuex'

//componentes
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import InputArchivos from '@/components/inputs/InputArchivos.vue'
import InputArchGen from '@/components/inputs/InputArchGen.vue'
import InputButton from '@/components/inputs/InputButton.vue'

//import formPreAfi
import FormPreAfi from '@/components/forms/FormPreAfi.vue'
import FormConyuge from '@/components/forms/FormConyuge.vue'

import FormPreNivel from '@/components/forms/FormPreNivel.vue'
//import formPreAfi
import FormDatosAfi from '@/components/forms/FormDatosAfi.vue'

//import fotoCarnet
import FormFotoCarnet from '@/components/forms/FormFotoCarnet.vue'

//import FormFotoyArch from '@/components/forms/FormFotoyArch.vue'
import FormPreFotoCarnet from '@/components/forms/FormPreFotoCarnet.vue'

//import formContactos
import FormEditarMail from '@/components/forms/FormEditarMail.vue'
import FormEditarDomicilios from '@/components/forms/FormEditarDomicilios.vue'
import FormEditarTelefono from '@/components/forms/FormEditarTelefono.vue'

//import formConyuge
import FormFamiliar from '@/components/forms/FormEditarFam.vue'

//import formProfesionales
import FormProfesionales from '@/components/forms/FormEditarDatosProf'

//import formNivel
import FormNivel from '@/components/forms/FormNivel.vue'
import FormVideoNivel from '@/components/forms/FormVideoNivel.vue'
import FormFotoCarnetPers from '@/components/forms/FormFotoCarnetPers'
import FormEditarFoto from '@/components/forms/FormEditarFoto'


//import de prueba
import FormPreContacto from '@/components/forms/FormPreContacto.vue'

export default {
    name: 'ExpansionPanelGen',

    components: {
        //Formu pre-afi
        FormPreAfi,
        FormPreContacto,
        //Formu datosafi
        FormDatosAfi,
        //Formularios de contactos
        FormEditarMail,
        FormEditarDomicilios,
        FormEditarTelefono,
        //Formu familiar
        FormFamiliar,
        //Formu familiar
        FormProfesionales,
        //Formu nivel
        FormNivel,
        FormVideoNivel,
        //Componentes
        InputArchivos,
        InputArchGen,
        //Formu foto y archivo
        //FormFotoyArch,
        //Formu de prueba
        ValidationObserver,
        ValidationProvider,
        InputButton,
        FormPreFotoCarnet,
        FormFotoCarnetPers,
        FormEditarFoto,

        FormFotoCarnet,

        FormConyuge,
        FormPreNivel,
    },
    data() {
        return {
            pan: 0,
            allCorrect: [],
            expand: false,
            disabled: false,
        }
    },
    beforeMount() {
        this.allCorrect = new Array(this.dim).fill(false)
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapGetters('stepper', ['e1']),
        ...mapGetters('notificaciones', ['loading']),
    },
    methods: {

        //  modificacion archivos de preafiliacion 
        ...mapActions('preafiliacion', ['addFilesPre', 'deleteItemPre']),

        //  guardado de datos en dataUser
        ...mapActions('dataUser', ['addFiles']),

        // correspondientes a las notificacioness
        ...mapActions('notificaciones', ['showSnack']),

        // manejador de validaciones
        formCorrect(data) {
            if (data.files) {
                if (data.files.length !== 0) {
                    if (data.op) {
                        if (this.isAuthenticated) {
                            this.addFiles({ file: data.files, op: data.op })
                        } else {
                            this.addFilesPre({ file: data.files, op: data.op })
                        }
                    }
                }
                else {
                    this.showSnack({
                        type: '400',
                        message: 'No hay archivos guardados.'
                    })
                }
            }
            this.allCorrect[data.index] = data.valid
            //desplaza el panel
            if (!data.tipo) {
                this.pan = this.pan + 1
            }

            //emite a FormularioAfiliacion el arreglo para ser evaluado
            this.$emit('pasoCompleto', this.allCorrect)
        },
        selectId(value) {
            console.log(value)
        }
    },
    props: ['items', 'dim', 'title', 'focusable', 'popout']
}
</script>